import React, { useContext, useRef, useEffect } from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router";
import { useMutation } from "@tanstack/react-query";

import {
    getCustomer,
    refetchCustomer,
    NotificationContext,
    handleError,
} from "../router";

import * as QUERIES from "../query-functions";

import LoadingIndicator from "../components/loading-indicator";
import LogoutButton from "../components/logout-button";
import AvatarCircle from "../svg/avatar-circle";

export default function Login() {
    const { notification, setNotification } = useContext(NotificationContext);
    const { data: customer, isPending, isFetching } = getCustomer();
    const [searchParams, setSearchParams] = useSearchParams();

    const containerRef = useRef(null);
    const navigate = useNavigate();
    const redirect_param = searchParams.get("r");
    const location = useLocation();
    const from = redirect_param
        ? redirect_param
        : location.state?.from?.pathname
          ? location.state.from.pathname
          : "/checkout/";

    const logOut = useMutation({
        mutationFn: () => QUERIES.logOut(),
        onError: (error) => {
            handleError(error.message, setNotification);
        },
        onSuccess: (data) => {
            window.location.reload();
        },
    });

    useEffect(() => {
        const loginFormTemplate = document.getElementById("loginForm");

        if (!loginFormTemplate || !containerRef.current || customer) return;

        const clone = loginFormTemplate.content.cloneNode(true);
        containerRef.current.innerHTML = "";
        containerRef.current.appendChild(clone);
    }, [containerRef.current, customer, isPending, isFetching]);

    useEffect(() => {
        // This event is dispatched by <spektrix-login>.
        // Capture it here to redirect.
        document.addEventListener("loginSuccess", () => {
            if (from) {
                window.location.href = from;
            } else {
                refetchCustomer();
            }
        });
    }, [from]);

    if (isPending) return <LoadingIndicator type="page" />;
    return (
        <div className="booking-pathway__container booking-pathway__login">
            <div className="booking-pathway__main-content">
                {!customer && (
                    <>
                        <h1 className="booking-pathway__header">
                            <AvatarCircle /> Login
                        </h1>

                        <div
                            ref={containerRef}
                            className="booking-pathway__login--form"
                        ></div>
                    </>
                )}

                {customer && (
                    <>
                        <h1 className="booking-pathway__header">
                            <AvatarCircle /> Logout
                        </h1>

                        <div className="booking-pathway__introduction">
                            <p>
                                Hello {customer.firstName}, you are logged in.
                                If you would like to change user please logout.
                            </p>
                        </div>

                        <LogoutButton />
                    </>
                )}
            </div>
        </div>
    );
}
